export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-next-54ac487d6c358661caa58fca92f55490.svg";